import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '1.5rem',
    },
    paddingLeft: '1rem',
    fontSize: '2.5rem',
    color: '#fff',
    alignItems: 'center',
    display: 'flex',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#A4A4A4',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
  inputSourceButtonContainer: {
    [theme.breakpoints.down(623)]: {
      width: '100%',
      fontSize: '11px',
      flexWrap: 'wrap',
      alignItems: 'stretch',
      gap: '0.2rem 0',
    },
    fontSize: '12px',
    display: 'inline-flex',
    margin: '1.5rem 0 0 0',
    backgroundColor: '#818181',
    padding: '0.2rem',
  },
  inputSourceButton: {
    [theme.breakpoints.down(623)]: {
      padding: '0.4rem 0.8rem!important',
      flexGrow: 1,
    },
    fontWeight: '400',
    backgroundColor: '#818181!important',
    color: '#000!important',
    padding: '0.3rem 1.1rem!important',
    border: 'none!important',
    width: 'auto',
  },
  selected: {
    backgroundColor: '#F0F0F0!important',
    borderRadius: '0.2rem!important',
  },
  cardGrid: {
    [theme.breakpoints.down('sm')]: {
      marginRight: '0',
    },
    marginRight: '3rem',
  },
  card: {
    justifyContent: 'stretch',
    display: 'flex',
    border: '0.1rem solid #fafafa',
    backgroundColor: '#161616',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    maxWidth: '50rem',
    marginBottom: '1rem',
    marginRight: '3rem',
    minHeight: '4rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'none',
      marginRight: '0',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
    },
  },
  clickableCard: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardLabel: {
    flex: 1,
    margin: '0.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  editIcon: {
    width: '1.5rem!important',
    marginLeft: '0.3rem',
    cursor: 'pointer',
  },
  cardTimestamp: {
    width: '9.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '4rem',
    },
  },
  cardStatus: {
    textAlign: 'center',
    marginLeft: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '0.8rem',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      marginLeft: '0rem',
    },
  },
  cardAction: {
    cursor: 'pointer',
    width: '2.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '0.3rem',
    [theme.breakpoints.down('xs')]: {
      width: '2.5rem',
    },
  },
  tooltipImg: {
    marginLeft: '0.5rem',
    width: '1.3rem',
  },
  searchbar: {
    [theme.breakpoints.down('xs')]: {
      padding: '0.2rem 0.5rem!important',
    },
    '&::placeholder': {
      color: '#818181',
      fontSize: '0.9rem',
      fontWeight: '400',
      border: 'none!important',
    },
    margin: '0.5rem 0',
    width: '45.5rem',
    maxWidth: '-webkit-fill-available',
    height: '2.5rem',
    borderRadius: '0.2rem',
    border: 'none!important',
    padding: '1rem',
    color: '#000',
    fontSize: '16px',
    fontWeight: '400',
    outline: 'none',
  },
  infoIconAction: {
    width: '2.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '0.3rem',
    [theme.breakpoints.down('xs')]: {
      width: '2.5rem',
    },
  },
  infoIconImg: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentcolor',
    flexShrink: '0',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
  },
  infoIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '0.2rem',
    color: '#161616',
  },
  infoIconTextContainer: {
    flexDirection: 'column',
    alignItems: 'stretch',
    color: '#161616',
  },
  infoIconTextLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.2rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  infoIconTextBold: {
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  infoIconText: {
    fontSize: '0.9rem',
    fontWeight: '400',
  },
  infoIconList: {
    margin: 0,
    paddingLeft: '1rem',
  },
  infoIconListItem: {
    fontSize: '0.8rem',
    fontWeight: 400,
    margin: '0.2rem 0',
  },
  pagination: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#ffffff',
    margin: '1rem 0',
  },

  coverImg: {
    [theme.breakpoints.down('xs')]: {},
    userSelect: 'none',
    width: '5.5rem',
    height: '5.5rem',
    display: 'inline-block',
    fill: 'currentcolor',
    flexShrink: '1',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
    borderRadius: '0.3rem',
    border: '0.07rem solid #808080',
    alignItems: 'flex-end',
  },
  playButtonImg: {
    userSelect: 'none',
    //display: "inline-block",
    //marginLeft: "0.5rem",
    //fill: "currentcolor",
    flexShrink: '0',
    //transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: '50px',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  communityDeleteButtonImg: {
    marginLeft: '0.2rem',
    cursor: 'pointer',
  },
  playButtonGrid: {
    direction: 'row-reverse',
    justifyContent: 'flex-end',
  },
  likeButtonImg: {
    marginTop: '3.2rem',
    userSelect: 'none',
    display: 'inline-block',
    marginLeft: '0.5rem',
    //fill: "currentcolor",
    flexShrink: '0',
    //transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: '2px',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  favoriteImg: {
    userSelect: 'none',
    //display: "inline-block",
    //fill: "currentcolor",
    flexShrink: '0',
    //transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: '2rem',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  favoriteFullImg: {
    userSelect: 'none',
    //display: "inline-block",
    //fill: "currentcolor",
    flexShrink: '0',
    //transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: '2rem',
    cursor: 'pointer',
    borderRadius: '0.1rem',
    //color: "#ff0000",
    color: '#d32f2f',
  },
  numberLikes: {
    //marginTop: "3.5rem",
    fontSize: '0.8rem',
    marginLeft: '.1rem',
    marginRight: '.1rem',
  },
  communityCardGrid: {
    //border: "1px solid #fafafa",
    columnGap: '15px',
  },
  communityCard: {
    //justifyContent: "stretch",
    display: 'flex',
    border: '0.1rem solid #fafafa',

    backgroundColor: '#161616',
    padding: '.7rem',
    paddingBottom: '.5rem',
    paddingRight: '1rem',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    maxWidth: '50rem',
    marginBottom: '1rem',
    //marginRight: "1rem",
    minHeight: '2rem',
    marginRight: '1rem',

    /*[theme.breakpoints.down("sm")]: {
      maxWidth: "25rem",
    },
    */
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      marginRight: '0.5',
    },
    [theme.breakpoints.down(476)]: {
      fontSize: '0.75rem',
      padding: '.4rem',
      paddingBottom: '.3rem',
    },
  },
  communityCardSecondColumn: {
    flex: 'vertical',
  },
  communityCardLabelUsername: {
    display: 'grid',

    //placeItems: "center",
    textOverflow: 'ellipsis',
  },
  communityCardLabel: {
    flex: 1,
    marginLeft: '0.7rem',
    display: 'flex',
    alignItems: 'top',
    fontSize: '1.3rem',
    flexWrap: 'wrap',
    height: '3.02rem',
    display: 'inline-block',
    overflow: 'hidden',
    overflowWrap: 'break-word',
    //whiteSpace: "nowrap",
    //textOverflow: "ellipsis",
  },
  communityCardUsername: {
    alightItems: 'flex-end',
    display: 'flex',
    marginLeft: '0.7rem',
    flex: 1,
    fontSize: '0.9rem',
    textOverflow: 'ellipsis',
    color: '#d3d3d3',
    height: '0.8rem',
  },
  communityEditIcon: {
    width: '1.2rem!important',
    marginLeft: '0.3rem',
    cursor: 'pointer',
  },
  communityCardTimestamp: {
    //marginTop: "3.3rem",
    alightItems: 'bottom',
    display: 'flex',
    marginLeft: '0.3rem',
    flex: 1,
    fontSize: '0.7rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    //whiteSpace: "nowrap",
  },
  communityCardLikes: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '1.2rem',
  },
  communityCardBottomRight: {
    justifyContent: 'flex-end',
  },
  communityNumberPlayed: {
    color: '#d3d3d3',
    fontSize: '0.8rem',
    //marginLeft: "",
    //marginTop: ".2rem",
    marginLeft: '0.7rem',
  },
  communityCreations: {
    color: '#d3d3d3',
    fontSize: '0.6rem',
    //marginLeft: "",
    //marginTop: ".2rem",
    marginLeft: '.2rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginBottom: '0.07rem',
    //textOverflow: "ellipsis",
  },
  communityCreationsGrid: {
    alignItems: 'flex-end',
    marginBotton: '0.5rem',
  },
  communityCardStatus: {
    textAlign: 'center',
    marginLeft: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '0.8rem',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      marginLeft: '0rem',
    },
  },
  dropzone: {
    opacity: '30%',
  },
  voiceAutoComplete: {
    width: '45.5rem',
    maxWidth: '-webkit-fill-available',
    borderRadius: '0.2rem',
    border: 'none!important',
    outline: 'none',
    backgroundColor: '#fff',
    marginBottom: '0.5rem',
    display: 'flex!important',
    alignItems: 'center!important',
    justifyContent: 'center!important',
    fontFamily: 'TheJamsilRegular!important',
  },
}));

export { useStyles };
